import { connect } from 'react-redux'
import ExperienceSpan from './ExperienceSpan'

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
}

const ExperienceSpanContainer = connect(
    mapStateToProps,
)(ExperienceSpan)

export default ExperienceSpanContainer
